import { apiClient } from '@devd-client/api';
import { getToken, getOrgId } from '@devd-client/devd/auth';
import {
  AllGoalsResponse,
  GetGoalResponse,
  GoalDtoWithTeam,
  GoalPageResponse,
  MetricsListResponse,
  TeamsResponse,
} from '../helpers/goals.types';

export const getAllGoals = (team: string): Promise<AllGoalsResponse> =>
  apiClient(`/v1/goal/org/${getOrgId()}${team ? `?team=${team}` : ''}`, {
    method: 'GET',
    headers: {
      authorization: `bearer ${getToken()}`,
    },
  });

export const updateGoalSettings = (params: any): Promise<any> => {
  const { team, teams, ...data } = params;
  return apiClient(`/v1/goal/org/${getOrgId()}/team/${team}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      authorization: `bearer ${getToken()}`,
    },
    body: JSON.stringify(data),
  });
};

export const getGoalsPage = (): Promise<GoalPageResponse> =>
  apiClient(`/v2/account/org/${getOrgId()}/page/Goal`, {
    method: 'GET',
    headers: {
      authorization: `bearer ${getToken()}`,
    },
  });

//New API's
export const getTeams = (): Promise<TeamsResponse> =>
  apiClient(
    `/v2/team/${getOrgId()}/lite${
      /^\/contributors\/$/.test(window.location.pathname)
        ? `?employee=${window.location.pathname?.split('/')?.pop()}`
        : ''
    }`,
    {
      method: 'GET',
      headers: {
        authorization: `bearer ${getToken()}`,
      },
    }
  );

export const getMetricsList = (): Promise<MetricsListResponse> =>
  apiClient(`/v1/config/metric/org/${getOrgId()}?type=metric`, {
    method: 'GET',
    headers: {
      authorization: `bearer ${getToken()}`,
    },
  });

export const createGoal = (goalData: {
  title: string;
  description: string;
  scope: string;
  associatedIds?: string[];
  timeframe: string;
  startDate: string;
  endDate: string;
}): Promise<any> => {
  const payload = {
    orgId: getOrgId(),
    ...goalData,
  };

  return apiClient('/v1/goals', {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: `bearer ${getToken()}`,
    },
    body: JSON.stringify(payload),
  });
};

export const updateGoal = ({
  goalId,
  goalData,
}: {
  goalId: string;
  goalData: {
    title: string;
    description: string;
    scope: string;
    associatedIds?: string[];
    timeframe: string;
    startDate: string;
    endDate: string;
  };
}): Promise<any> => {
  const payload = {
    orgId: getOrgId(),
    ...goalData,
  };

  return apiClient(`/v1/goals/org/${getOrgId()}/${goalId}`, {
    method: 'PUT',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: `bearer ${getToken()}`,
    },
    body: JSON.stringify(payload),
  });
};

export const updateGoalKeyResults = ({
  goalId,
  keyResults,
}: {
  goalId: string;
  keyResults: Array<{
    title: string;
    metricName: string;
    metricOperator: string;
    targetValue: number;
    weight: number;
  }>;
}): Promise<any> => {
  return apiClient(`/v1/goals/org/${getOrgId()}/${goalId}/update/key-results`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: `bearer ${getToken()}`,
    },
    body: JSON.stringify(keyResults),
  });
};

export const getGoal = (goalId: string): Promise<GetGoalResponse> =>
  apiClient(`/v1/goals/org/${getOrgId()}/${goalId}`, {
    method: 'GET',
    headers: {
      authorization: `bearer ${getToken()}`,
    },
  });
